import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcModifyPatientConditionListItemDto, FcPatientConditionListItemDto } from 'webcommon/shared';
import { FcGenericItemModalBaseComponent, FcListValidationService } from '../../generic/index';
import { ApColorSelectorService } from './../../../shared/index';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'ap-fc-patient-condition-list-modal',
  templateUrl: './fc-patient-condition-list-modal.component.html',
})
export class FcPatientConditionListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-patient-condition-item';

  // List Item with default value
  public listItem: FcPatientConditionListItemDto = {
    Id: '',
    ExternalID: '',
    Color: '',
    Name: '',
    Notes: '',
    Inactive: false,
    UserDefined: true,
  };

  // Form Controls
  public externalIdControl: FormControl = new FormControl('');
  public textColorControl: FormControl = new FormControl('');
  public colorControl: FormControl = new FormControl('');
  public nameControl: FormControl = new FormControl('');
  public notesControl: FormControl = new FormControl('');
  public inactiveControl: FormControl = new FormControl(false);
  public userDefinedControl: FormControl = new FormControl(true);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    textColor: this.textColorControl,
    color: this.colorControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
  });

  constructor(injector: Injector, public apColorSelectorService: ApColorSelectorService) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 50,
      },
      Name: {
        IsRequired: true,
        IsUnique: true,
        MaxLength: 50,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setTextColorValue(): void {
    this.apColorSelectorService.appliedColor$
      .pipe(this.takeUntilDestroy())
      .subscribe((color: string) => {
        this.colorControl.setValue(color);
      });
  }

  public setForm(): void {
    // External Id Control
    this.setTextColorValue();
    this.fcListValidation.setValidatorsAndValue(this.externalIdControl, 'ExternalID', this.listItem.ExternalID);

    // Text Color Control
    this.fcListValidation.setValidatorsAndValue(this.colorControl, 'Color', this.listItem.Color);
    this.apColorSelectorService.setAppliedColor(this.listItem.Color);

    // Name Control
    const isNameControlDisabled = !this.listItem.UserDefined;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.fcListValidation.setValidatorsAndValue(this.nameControl, 'Name', this.listItem.Name);

    // Notes Control
    this.fcListValidation.setValidatorsAndValue(this.notesControl, 'Notes', this.listItem.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem.Inactive);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(this.listItem.UserDefined);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const modifyItemDto: FcModifyPatientConditionListItemDto = {
      ExternalID: values.externalId,
      Color: values.color,
      Name: values.name,
      Inactive: values.inactive,
      Notes: values.notes,
      UserDefined: values.userDefined,
    };
    super.save<FcModifyPatientConditionListItemDto>(modifyItemDto);
  }
}
